import { LocationType } from '@aviv-search/types';
export const setSearchType = (searchModel) => {
    if (!searchModel.locations[0])
        return null;
    const locationType = searchModel.locations[0].type;
    if (locationType === LocationType.PLACE_ID)
        return 'location';
    if (locationType === LocationType.RADIUS)
        return 'radius';
    if (locationType === LocationType.COMMUTE)
        return 'travel_time';
    return null;
};
